//报错通知类
class Alarm {
  notify(message, code, type = null, service) {
    console.log(message, code, type, service);
  }
}

export default Alarm;